<div
  class="video-player-container relative group w-full h-full flex items-center justify-center overflow-hidden rounded-lg bg-black"
  (mousemove)="onMouseMove()"
  (mouseleave)="onMouseLeave()"
>
  <!-- Video element -->
  <video
    #videoElement
    [src]="src"
    [poster]="poster"
    [autoplay]="autoplay"
    [muted]="muted"
    [loop]="loop"
    (loadedmetadata)="onLoadedMetadata()"
    (timeupdate)="onTimeUpdate()"
    (play)="onPlayStateChange(true)"
    (pause)="onPlayStateChange(false)"
    (ended)="onPlayStateChange(false)"
    (click)="togglePlay($event)"
    class="w-full h-full object-contain cursor-pointer"
    playsinline
  >
  </video>

  <!-- Control bar: matches user layout exactly, theme-aware and responsive to play state / hover -->
  <div
    class="absolute bottom-2 left-2 right-2 sm:bottom-3 sm:left-3 sm:right-3 flex items-center gap-1.5 sm:gap-3 px-2 py-1.5 sm:px-4 sm:py-2.5 rounded-lg border shadow-lg backdrop-blur-md transition-all duration-300 bg-white/90 border-neutral-200/80 text-neutral-800 dark:bg-neutral-950/85 dark:border-neutral-800/80 dark:text-neutral-100 select-none opacity-0 pointer-events-none"
    [class.opacity-100]="!isPlaying() || userActive()"
    [class.pointer-events-auto]="!isPlaying() || userActive()"
  >
    <!-- Play/Pause Button -->
    <button
      (click)="togglePlay($event)"
      type="button"
      class="flex items-center justify-center hover:opacity-80 transition-opacity focus:outline-none shrink-0"
      [attr.aria-label]="isPlaying() ? 'Pause' : 'Play'"
    >
      @if (isPlaying()) {
        <!-- Pause Icon -->
        <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-current" viewBox="0 0 24 24">
          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
        </svg>
      } @else {
        <!-- Play Icon (Solid Triangle) -->
        <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-current" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z"/>
        </svg>
      }
    </button>

    <!-- Current Time -->
    <span class="text-[10px] sm:text-[11px] font-medium font-mono shrink-0 select-none tracking-tight">
      {{ formatTime(currentTime()) }}
    </span>

    <!-- Scrubber -->
    <input
      type="range"
      min="0"
      [max]="duration() || 100"
      [value]="currentTime()"
      (input)="onSeek($event)"
      (click)="$event.stopPropagation()"
      class="video-player-slider flex-1 min-w-0 h-[3px] rounded-full appearance-none cursor-pointer outline-none transition-all duration-200"
      [style.background]="getScrubberBackground()"
    />

    <!-- Total Duration -->
    <span class="text-[10px] sm:text-[11px] font-medium font-mono shrink-0 select-none tracking-tight">
      {{ formatTime(duration()) }}
    </span>

    <!-- Fullscreen Button -->
    <button
      (click)="toggleFullscreen($event)"
      type="button"
      class="flex items-center justify-center hover:opacity-80 transition-opacity focus:outline-none shrink-0 ml-0.5 sm:ml-1"
      [attr.aria-label]="isFullscreen() ? 'Exit Fullscreen' : 'Enter Fullscreen'"
    >
      @if (isFullscreen()) {
        <!-- Minimize Icon -->
        <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-current" viewBox="0 0 24 24">
          <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
        </svg>
      } @else {
        <!-- Maximize Icon -->
        <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-current" viewBox="0 0 24 24">
          <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
        </svg>
      }
    </button>
  </div>
</div>
